






import Vue from 'vue';
import axios, { AxiosResponse, AxiosError } from 'axios';
import RoutePaths from '@/router/route_paths';
import BbTools from '@/tools/bluebird';
import xml2js from 'xml2js';
import firebase from 'firebase/app';
import store from '@/store';
import translationsOffline from '@/tools/DefaultTranslation297.json';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';
import { Lang } from '@/store/types';

require('firebase/auth');

let authListener: Function | null = null;
let authenticated = false;
export default Vue.extend({
  name: 'BbApp',
  data() {
    return {
    };
  },
  async mounted() {
    // set offline translations as default and then load actual translations from server
    store.commit('setTranslations', { ...translationsOffline });
    // UserTools.loadTranslations(this.$store, '297');
    await Promise.all([
      this.loadLanguagesISpeak(),
      this.loadTranslationsDefault(),
    ]);
    authListener = firebase.auth().onAuthStateChanged(async (user) => {
      if (!authenticated) {
        if (user) {
          authenticated = true;
          await UserTools.loginUser(this.$store, { ...user }, this.$router);
        } else {
          try {
            const langIFromStorage = localStorage.getItem(BbTools.LS_LAST_LANG_I);
            if (langIFromStorage === null || langIFromStorage === '') { // first launch
              await LearningTools.setNewLangIL(this.$store, BbTools.DEFAULT_LANG_I.id, null);
              this.displayLogin();
            } else {
              const langI: Lang = JSON.parse(langIFromStorage);
              await LearningTools.setNewLangIL(this.$store, langI.id, null);
              this.displayLogin();
            }
          } catch (error) {
            await LearningTools.setNewLangIL(this.$store, BbTools.DEFAULT_LANG_I.id, null);
            this.displayLogin();
          }
        }
      }
    });
  },
  methods: {
    displayLogin(): void {
      this.$router.push(RoutePaths.LOGIN);
    },
    async loadTranslationsDefault(): Promise<void> {
      const translationsOfflineClone: DOMStringMap = { ...translationsOffline };
      await axios.get(`${this.$store.getters.URL_TRANSLATIONS_DEFAULT}`, BbTools.bbHeaders)
        .then((response: AxiosResponse) => {
          try {
            xml2js.parseString(response.data, (error: Error, result: any) => {
              if (result) {
                const tr = result.ProMenu;
                Object.keys(tr).forEach((key: string) => {
                  tr[key] = BbTools.replaceAll(tr[key][0], /\\n/, '');
                  tr[key] = BbTools.replaceAll(tr[key], /\\'/, '\'');
                  translationsOfflineClone[key] = tr[key];
                });
              } else {
                this.$store.commit('setAlertMessage', {
                  text: 'Default translations error #1',
                  error,
                });
              }
            });
          } catch (error) {
            this.$store.commit('setAlertMessage', {
              text: 'Default translations error #2',
              error,
            });
          }
        })
        .catch((error: AxiosError) => {
          this.$store.commit('setAlertMessage', {
            text: 'Default translations error #3',
            error,
          });
        });
      this.$store.commit('setTranslationsDefault', translationsOfflineClone);
    },
    async loadLanguagesBluebird() {
      await axios.get(`${this.$store.getters.URL_LANGUAGES_BLUEBIRD}`, BbTools.bbHeaders)
        .then((response: AxiosResponse) => {
          try {
            xml2js.parseString(response.data, (error: Error, result: any) => {
              if (result && result.bb && result.bb.lang) {
                const langsBB: Array<string> = result.bb.lang;
                this.$store.commit('setLanguagesBluebird', langsBB);
                if (this.$store.state.langsI.length > 0) { // means that langsI are already loaded
                  const newLangsI: Array<Lang> = []; // remove languages that are not in langsBB
                  this.$store.state.langsI.forEach((langI: Lang) => {
                    if (langsBB.indexOf(langI.id) !== -1) {
                      newLangsI.push(langI);
                    }
                  });
                  this.$store.commit('setLangsI', newLangsI);
                }
              } else {
                this.$store.commit('setAlertMessage', {
                  text: 'Languages Bluebird error #1',
                  error,
                });
              }
            });
          } catch (error) {
            this.$store.commit('setAlertMessage', {
              text: 'Languages Bluebird error #2',
              error,
            });
          }
        })
        .catch((error: AxiosError) => {
          this.$store.commit('setAlertMessage', {
            text: 'Languages Bluebird error #3',
            error,
          });
        });
    },
    async loadLanguagesISpeak() {
      await axios.get(`${this.$store.getters.URL_LANGUAGES_ISPEAK}`, BbTools.bbHeaders)
        .then((response: AxiosResponse) => {
          const responseJson = response.data;
          if (responseJson.success !== true) {
            this.$store.commit('setAlertMessage', { text: 'Languages ISpeak error #1' });
            return;
          }
          const langsFromResponse = responseJson.data;
          let langsI = [];
          if (this.$store.state.languagesBluebird.length > 0) {
            // means that langsBB are already loaded - need to filter langsI
            langsFromResponse.forEach((lang: Lang) => {
              if (this.$store.state.languagesBluebird.indexOf(lang.id) !== -1) {
                langsI.push(lang);
              }
            });
          } else {
            langsI = langsFromResponse;
          }
          this.$store.commit('setLanguagesI', langsI);
        })
        .catch((error) => {
          this.$store.commit('setAlertMessage', {
            text: 'Languages ISpeak error #2',
            error,
          });
        });
    },
  },
});

